import React from 'react';
import { Link } from 'react-router-dom';


// image
import img from '../../images/about/snbs_4.jpg'
import SectionTitle from '../../components/SectionTitle/SectionTitle';

const about = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
        <section className={"" + props.hclass}>
            <div className="container">
                 {/* <SectionTitle subtitle={'Our Founder'} title={''} /> */}
                <div className="wpo-about-section-wrapper">
                    <div className="row align-items-center">
                         <div className="col-xl-6 col-lg-12 col-md-12 col-12">
                            <div className="wpo-about-img">
                                <div >
                                    <img src={img} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-12 col-md-12 col-12">
                            <div className="wpo-about-content ">
                                <div className="wpo-about-content-top" style={{textAlign:"justify"}}>
                                    <h2>Our Founder</h2>
                                    <p>It gives me immense pleasure to extend my heartfelt gratitude to our valued customers, partners, and team members who have been an integral part of our journey.

                                    At SNBS Industries Pvt. Ltd., our goal has always been to deliver quality. innovation, and trust across every product and service we offer.</p>
 
                                   <p> In today's rapidly evolving industrial landscape, adaptability and forward-thinking are key. We continuously invest in advanced technology, skilled manpower, and sustainable practices to ensure that we not only meet but exceed the expectations of our customers.

                                    Our goal is not only to be a market leader but also to contribute meaningfully to the economy and society. We believe in building long-term relationships founded on integrity, performance, and mutual growth.

                                    As we move ahead, I assure you of our continued dedication, and i invite you to be part of our ongoing success story.</p>
                                </div>
                                <div className="wpo-about-content-progress">
                                    <div className="progress-inner">
                                        {/* <div className="progress yellow">
                                            <span className="progress-left">
                                                <span className="progress-bar"></span>
                                            </span>
                                            <span className="progress-right">
                                                <span className="progress-bar"></span>
                                            </span>
                                            <div className="progress-value">98%</div>
                                            <div className="progress-name"><span>Success</span></div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
        </section>
    );
};

export default about;

